import React, { useState } from "react";
import moment from "moment";
// import { Decimal } from 'decimal.js';
import { Flex, WhiteSpace, InputItem, Picker, List, Button, Toast, DatePicker, NoticeBar } from "antd-mobile";
import { createForm } from "rc-form";

import { CustomerFilter } from "../components/CommonFilter";
import { CountryFilter } from "../components/CountryFilter";
import { PurposeFilter } from "../components/PurposeFilter";
// import { Radios } from '../components';

import {
  RecordTypeId,
  RecordCreateType,
  BillType,
  ForeignDefaultBillConfigDiscount,
  ChargeTypeEnum
} from "../utils/const";
import { calculateBillUnit, PriceDivide } from "../utils/common";
import { BatchCreateCustomerPaidConfig, CreateDefaultCustomerPaidConfig } from "../../../api/order";
import { AddLogRecord } from "../../../api/usms";

export const DefaultBillType = 1;
export const SpecialBillType = 2;

function InnerDiscountConfigForm({ accountIdOptions, ChargeType, CompanyId, form, callback, defaultConfigList, foreignFilterList }) {
  const [formData, setFormData] = useState({
    ChargeType: [ChargeType],
    BillType: [2]
  });
  const [chargeTypeList] = useState([{ label: "实时扣费", value: ChargeType }]);
  const [errors, setErrors] = useState({});
  const [defaultPrice, setDefaultPrice] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [defaultConfigDisabled, setDefaultConfigDisabled] = useState(false);

  const BillTypeOptions = Object.keys(BillType)
  .filter(item => !(Number(item) === DefaultBillType && defaultConfigDisabled))
  .map(item => {
    return {
      label: BillType[item],
      value: +item,
    };
  });

  const dealParams = values => {
    const {
      BillType,
      AccountId,
      Purpose,
      ValidStartTime,
      ChargeType,
      BrevityCode,
      SettlementPriceDiscount,
      // MinDiscount
    } = values;
    let baseParams = {
      AccountId: AccountId[0],
      ChargeType: ChargeType[0]
    },
      params = {};

    // 默认配置
    if (BillType.includes(1)) {
      params = {
        ...baseParams,
        // Purpose: isWhatsApp ? 0 : Purpose,
        Action: CreateDefaultCustomerPaidConfig,
        Purpose: Purpose[0],
        DomesticFlag: "Foreign"
      };
      // if (isWhatsApp) {
      //   params.ConversationType = ConversationType;
      // }
    } else {
      params = {
        ...baseParams,
        ValidStartTime: moment(ValidStartTime).unix(),
        Action: BatchCreateCustomerPaidConfig,
        Configs: [
          {
            Purpose: Purpose[0],
            BrevityCode: BrevityCode[0],
            SettlementPriceDiscount: +SettlementPriceDiscount,
            MinDiscount: +SettlementPriceDiscount,
            // MinDiscount: +MinDiscount
          }
        ]
      };
    }
    return params;
  };

  const onFinish = ({ Action, ...params }) => {
    setConfirmLoading(true);

    // 新接口
    Action(params).then(res => {
      const { RetCode } = res;
      if (RetCode === 0) {
        Toast.success("设置成功");
        try {
          AddLogRecord({
            RecordTypeId: RecordTypeId.CustomerBillConfig,
            OperatorTypeId: RecordCreateType,
            RelatedId: CompanyId + "",
            Content: `创建内部折扣（移动端）${ChargeTypeEnum[ChargeType]}${BillType === 1 ? "默认" : ""
              }配置：${JSON.stringify(params)}`
          });
        } catch (err) {
          console.log("err", err);
        }

        callback();
      }
      setConfirmLoading(false);
    });
  };

  const onConfirm = () => {
    // form.validateFields((error, value) => {
    // });
    const BillType = formData.BillType;

    const error = {};
    if (!formData.AccountId || !formData.AccountId.length) {
      error.AccountId = "请选择项目ID";
    }
    if (!formData.ChargeType || !formData.ChargeType.length) {
      error.ChargeType = "请选择计费类型";
    }
    if (!formData.Purpose || !formData.Purpose.length) {
      error.Purpose = "请选择短信类型";
    }
    if (!formData.BillType || !formData.BillType.length) {
      error.BillType = "请选择配置类型";
    }
    if (!BillType.includes(1)) {
      if (!formData.BrevityCode || !formData.BrevityCode.length) {
        error.BrevityCode = "请选择国家";
      }
      // if (!formData.MinPrice || isNaN(formData.MinPrice)) {
      //   error.MinPrice = "售价必须是数字";
      // }
      if (!formData.SettlementPrice || isNaN(formData.SettlementPrice)) {
        error.SettlementPrice = "结算价必须是数字";
      }
      if (!formData.ValidStartTime || isNaN(formData.ValidStartTime)) {
        error.ValidStartTime = "生效时间必填";
      }
    }

    setErrors(error);

    if (Object.keys(error).length > 0) {
      return;
    }

    onFinish(dealParams(formData));
  };

  const onChange = (values, type) => {
    const { BrevityCode, Purpose, ChargeType } = formData;

    if (BrevityCode && BrevityCode.length && Purpose && Purpose.length && ChargeType && ChargeType.length) {
      // 输入最低售价，自动计算最低折扣
      const basePrice = calculateBillUnit(
        (
          defaultConfigList.filter(
            item =>
              item.BrevityCode === BrevityCode[0] &&
              item.Purpose === Purpose[0] &&
              item.ChargeType === ChargeType[0]
          )[0] || {}
        ).Price || 0
      );
      setDefaultPrice(basePrice);
      // if (type === "MinPrice" && basePrice > 0) {
      //   if (values && values !== "") {
      //     const price = Number(values);
      //     const discount = PriceDivide(price, basePrice);
      //     setFormData({
      //       ...formData,
      //       MinPrice: values,
      //       MinDiscount: discount
      //     });
      //   } else {
      //     setFormData({
      //       ...formData,
      //       MinPrice: values,
      //       MinDiscount: null
      //     });
      //   }
      // }

      if (type === "SettlementPrice" && basePrice > 0) {
        if (values && values !== "") {
          const price = Number(values);
          const discount = PriceDivide(price, basePrice);
          setFormData({
            ...formData,
            SettlementPrice: values,
            SettlementPriceDiscount: discount
          });
        } else {
          setFormData({
            ...formData,
            SettlementPrice: values,
            SettlementPriceDiscount: null
          });
        }
      }
    }
  };

  const onPurposeChange = (v) => {
    const data = {
      ...formData,
      Purpose: v,
      MinPrice: "",
      SettlementPrice: ""
    };

    if (
      foreignFilterList &&
      foreignFilterList.length > 0 &&
      foreignFilterList.findIndex((item) => item.Purpose === v[0]) > -1
    ) {
      setFormData({ ...data, BillType: [SpecialBillType] });
      setDefaultConfigDisabled(true);
    } else {
      setFormData({ ...data });
      setDefaultConfigDisabled(false);
    }
  }

  return (
    <Flex direction="column">
      <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
        <Picker data={chargeTypeList} cols={1} value={formData.ChargeType} disabled>
          <List.Item arrow="horizontal">计费类型</List.Item>
        </Picker>
        <p style={{ color: "red", paddingLeft: "16px" }}>{errors.ChargeType || null}</p>
      </Flex.Item>
      <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
        <CustomerFilter
          options={accountIdOptions || []}
          value={formData.AccountId}
          onChange={v => {
            setFormData({
              ...formData,
              AccountId: v
            });
          }}
        />
        <p style={{ color: "red", paddingLeft: "16px" }}>{errors.AccountId || null}</p>
      </Flex.Item>
      <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
        <PurposeFilter
          value={formData.Purpose}
          onChange={v => {
            onPurposeChange(v);
          }}
        />
        <p style={{ color: "red", paddingLeft: "16px" }}>{errors.Purpose || null}</p>
      </Flex.Item>
      <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
        <Picker
          data={BillTypeOptions}
          cols={1}
          value={formData.BillType}
          onChange={v =>
            setFormData({
              ...formData,
              BillType: v
            })
          }
        >
          <List.Item arrow="horizontal">配置类型</List.Item>
        </Picker>
        <p style={{ color: "red", paddingLeft: "16px" }}>{errors.BillType || null}</p>
      </Flex.Item>
      {formData.BillType.includes(2) ? (
        <>
          <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
            <CountryFilter
              disableAll
              value={formData.BrevityCode}
              onChange={v => {
                setFormData({
                  ...formData,
                  BrevityCode: v,
                  MinPrice: "",
                  SettlementPrice: ""
                });
              }}
            />
            <p style={{ color: "red", paddingLeft: "16px" }}>{errors.BrevityCode || null}</p>
          </Flex.Item>
          {/* <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
            <InputItem
              type="digit"
              placeholder="请输入最低售价"
              clear
              extra="$"
              labelNumber={16}
              min={0}
              value={formData.MinPrice}
              moneyKeyboardAlign="left"
              moneyKeyboardWrapProps={{
                onTouchStart: e => e.preventDefault()
              }}
              onChange={v => onChange(v, "MinPrice")}
            >
              最低售价
            </InputItem>
            <p style={{ color: "red", paddingLeft: "16px" }}>{errors.MinPrice || null}</p>
          </Flex.Item>
          <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
            <InputItem
              type="text"
              placeholder="小数(0.5表示50%)"
              clear
              disabled
              value={formData.MinDiscount}
            >
              最低折扣
            </InputItem>
            <p style={{ color: "red", paddingLeft: "16px" }}>{errors.MinDiscount || null}</p>
          </Flex.Item> */}
          <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
            <InputItem
              type="digit"
              placeholder="请输入内部结算价"
              clear
              min={0}
              extra="$"
              value={formData.SettlementPrice}
              labelNumber={16}
              moneyKeyboardAlign="left"
              moneyKeyboardWrapProps={{
                onTouchStart: e => e.preventDefault()
              }}
              onChange={v => onChange(v, "SettlementPrice")}
            >
              内部结算价
            </InputItem>
            <p style={{ color: "red", paddingLeft: "16px" }}>{errors.SettlementPrice || null}</p>
          </Flex.Item>
          <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
            <InputItem
              type="text"
              placeholder="小数(0.5表示50%)"
              clear
              disabled
              value={formData.SettlementPriceDiscount}
            >
              内部结算折扣
            </InputItem>
            <p style={{ color: "red", paddingLeft: "16px" }}>{errors.SettlementPriceDiscount || null}</p>
          </Flex.Item>
          <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
            <DatePicker
              mode="date"
              title="生效时间"
              extra="每月1日生效"
              minDate={moment()
                .startOf("day")
                .toDate()}
              value={formData.ValidStartTime}
              onChange={date => {
                setFormData({
                  ...formData,
                  ValidStartTime: date
                });
              }}
            >
              <List.Item arrow="horizontal">生效时间</List.Item>
            </DatePicker>
            <p style={{ color: "red", paddingLeft: "16px" }}>{errors.ValidStartTime || null}</p>
          </Flex.Item>

          <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
            {defaultPrice === 0 ? (
              <NoticeBar marqueeProps={{ loop: false, style: { padding: "0 7.5px" } }}>
                该类型和国家码未配置计费ID，请先申请计费ID并联系管理员进行配置
              </NoticeBar>
            ) : null}
          </Flex.Item>
        </>
      ) : (
        <Flex.Item style={{ marginTop: "8px", marginBottom: "4px", width: "100%" }}>
          <NoticeBar marqueeProps={{ loop: false, style: { padding: "0 7.5px" } }}>
            最低折扣：{ForeignDefaultBillConfigDiscount.MinDiscount}%，内部结算折扣：
            {ForeignDefaultBillConfigDiscount.SettlementPriceDiscount}%
          </NoticeBar>
        </Flex.Item>
      )}

      <WhiteSpace />
      <WhiteSpace />
      <Button
        style={{ width: "100%" }}
        loading={confirmLoading}
        disabled={confirmLoading}
        onClick={onConfirm}
        type="primary"
      >
        确定
      </Button>
      <WhiteSpace />
    </Flex>
  );
}

export default createForm()(InnerDiscountConfigForm);
